<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-offset-2 is-8">
            <div class="box">
              <h1 class="title">ユーザー情報編集</h1>
              <div class="field">
                <label class="label">表示名</label>
                <div class="control">
                  <input class="input" type="text" placeholder="表示名" v-model="inputForm.dispname" disabled>
                </div>
              </div>
              <div class="field">
                <label class="label">新しいパスワード</label>
                <div class="control">
                  <input class="input" type="password" placeholder="パスワード" v-model="inputForm.password">
                </div>
              </div>
              <div class="field">
                <label class="label">確認のためもう一度</label>
                <div class="control">
                  <input class="input" type="password" placeholder="パスワード" v-model="inputForm.confirmPassword">
                </div>
              </div>
              <button class="button is-link" v-on:click="update">確　定</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  data: function(){
    return {
      showModal: false,
      inputForm: {
        id: 0,
        dispname: '',
        password: '',
        confirmPassword: '',
      },
      error:{
        message: null
      }
    }
  },
  computed:{
    ...mapGetters({
      getUser: 'item/getUser'
    }),
    ...mapState({
      apiStatus: state => state.item.apiStatus,
      user: state => state.auth.user,

    })
  },
  mounted (){
    const usre = this.getUser(this.$route.params.memberId)
    this.$set(this.inputForm, 'id', usre.id)
    this.$set(this.inputForm, 'dispname', usre.dispname)
  },
  methods: {
    clearError(){
      //初期化
      Object.keys(this.error).forEach((key) => {
        this.$set(this.error, key, null)
      })
    },
    async update(){
      this.clearError()
      if(this.inputForm.password.length < 6 ){
          this.error.message = 'パスワードは最低6文字以上を設定してください';
      } else if (this.inputForm.password !== this.inputForm.confirmPassword) {
          this.error.message = 'パスワードが一致しません';
      }
      if(this.error.message){
        this.$swal({
          title: '確認',
          text: this.error.message,
          icon: 'error',
          confirmButtonText: '戻る',
        })
        return false
      }
      await this.$store.dispatch('item/password', this.inputForm)
      if(this.apiStatus){
        this.$set(this.inputForm, 'password', '')
        this.$set(this.inputForm, 'confirmPassword', '')
        this.$swal({
          position: 'top-end',
          icon: 'success',
          title: 'データを更新しました。',
          showConfirmButton: false,
          timer: 2000
        })
      }
    }
  }
}
</script>